<template>
  <div class="mfm-container">
    <b-tabs justified style="padding-top: 12px">
      <b-tab :title="$t('map.convenience_facility')">
        <div class="tab_wrap">
          <b-button
            variant="white"
            class="noborder item"
            v-for="(v, i) in $store.getters.fcItems[0]"
            :key="i"
            @click="onClick(0, i, !v.active, v)"
          >
            <b-img :src="v.active ? v.ic_active : v.ic_inactive" /><br /><span
              >{{ v.text }}</span
            >
          </b-button>
        </div>
      </b-tab>
      <b-tab :title="$t('map.district_info')">
        <div class="tab_wrap">
          <b-button
            variant="white"
            class="noborder item"
            v-for="(v, i) in $store.getters.fcItems[1]"
            :key="i"
            @click="onClick(1, i, !v.active, v)"
          >
            <b-img :src="v.active ? v.ic_active : v.ic_inactive" /><br /><span
              >{{ v.text }}</span
            >
          </b-button>
          <div class="item" />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "MFMap",
  props: ["web"],
  methods: {
    onClick(i, j, v, item) {
      //???여기에 지도필터기능을 추가
      // this.$refs.webref.contentWindow.postMessage(
      //   { type: "2", state: item.active, idx: item.idx },
      //   "*"
      // );
      this.$emit("facilityClick", item);
      this.$store.commit("setFcItemActive", { i: i, j: j, v: v });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/_vars.scss";
div.mfm-container {
  background-color: white;
  box-shadow: black 1px -3px 8px -6px;
  height: 180px;
}
button {
  margin-left: 3px;
  padding-left: 0;
  padding-right: 0;
  width: 3.8em;
  font-size: 0.8em;
}
img {
  width: 2.5em;
  height: 2.5em;
  margin-bottom: 5px;
}

.tab_wrap {
  height: 102px;
  display: flex;
  justify-content: flex-start;
}
.item {
  flex: 1;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  color: #242424;
  margin-top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFMap.vue